import React from "react";
import { Button } from "../../../../../design/button";
import { Field, Label } from "../../../../../design/fieldset";
import OnboardingContainer from "../../../components/OnboardingContainer";
import { Input } from "../../../../../design/input";
import { Professional } from "../../../../../models/Professional";

const OnboardingPersonalInfoStep: React.FC<{
  formData: Partial<Professional>;
  setFormData: React.Dispatch<React.SetStateAction<Partial<Professional>>>;
  onBack: () => void;
  onStepComplete: () => void;
}> = ({ formData, setFormData, onBack, onStepComplete }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onStepComplete();
  };

  return (
    <OnboardingContainer title="Your Information">
      <>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-4">
            <Field>
              <Label>First Name</Label>
              <Input
                placeholder="First Name"
                value={formData.firstName || ""}
                onChange={(e) =>
                  setFormData({ ...formData, firstName: e.target.value })
                }
                required
              />
            </Field>
            <Field>
              <Label>Last Name</Label>
              <Input
                placeholder="Last Name"
                value={formData.lastName || ""}
                onChange={(e) =>
                  setFormData({ ...formData, lastName: e.target.value })
                }
                required
              />
            </Field>
          </div>
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-4">
            <Field>
              <Label>Email</Label>
              <Input
                placeholder="Email"
                type="email"
                value={formData.email || ""}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                required
              />
            </Field>
            <Field>
              <Label>Phone Number</Label>
              <Input
                placeholder="(123) 456-7890"
                type="tel"
                value={formData.phoneNumber || ""}
                onChange={(e) =>
                  setFormData({ ...formData, phoneNumber: e.target.value })
                }
              />
            </Field>
          </div>
          <Field>
            <Label>Organization</Label>
            <Input
              placeholder="Your Organization"
              value={formData.organization || ""}
              onChange={(e) =>
                setFormData({ ...formData, organization: e.target.value })
              }
            />
          </Field>

          <div className="flex justify-between gap-4">
            <Button type="button" onClick={onBack}>
              Back
            </Button>
            <Button type="submit">Continue</Button>
          </div>
        </form>
      </>
    </OnboardingContainer>
  );
};

export default OnboardingPersonalInfoStep;
